import { gql } from '@apollo/client'
import { useQuery, useMutation } from '@apollo/client/react'
import { get } from 'lodash'

export const MY_MERCHANT_INVITES = gql`
	query GetMyMerchantInvites {
		myInvites{
			inviteID
			email
			status
			merchant{
				id
				name
				logoUrl
				country
			}
			invitedBy{
				id
				firstName
				lastName
			}
		}
	}
`

const ACCEPT_INVITE = gql`
	mutation AcceptMerchantInvite($inviteID: Int!) {
		acceptMerchantInvite(inviteID: $inviteID)
	}
`

export const useMyMerchantInvites = () => {
	const { data, loading } = useQuery(MY_MERCHANT_INVITES)
	const invites = get(data, 'myInvites')
	return { invites, loading }
}

export const useAcceptMerchantInvite = () => {
	const [acceptMerchantInvite ] = useMutation(ACCEPT_INVITE, {
		refetchQueries: [			
			{
				query: MY_MERCHANT_INVITES,
			},
		]}
	)
	return { acceptMerchantInvite }
}

export const useHasOpenInvites = () => {
	const { data, error, loading } = useQuery(MY_MERCHANT_INVITES);
  
	const invites = get(data, 'myInvites', []);
  
	const hasOpenInvites = invites.some(invite => invite.status === 'open');
  
	return { hasOpenInvites, error, loading };
  };
